import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { ListItem, UnorderedList, Flex } from '@chakra-ui/react';
import Link from '@components/atoms/Link';
import { dataLayerClick } from '@helpers/dataLayerPush';

const FooterMenu = () => {
  const { footer1, footer2 } = useStaticQuery(graphql`
    {
      footer1: strapiMenus(attributes: { slug: { eq: "footer-menu-1" } }) {
        attributes {
          title
          slug
          items {
            data {
              attributes {
                title
                url
              }
            }
          }
        }
      }

      footer2: strapiMenus(attributes: { slug: { eq: "footer-menu-2" } }) {
        attributes {
          title
          slug
          items {
            data {
              attributes {
                title
                url
              }
            }
          }
        }
      }
    }
  `);

  const footerMenu1 = footer1.attributes.items.data || ``;
  const footerMenu2 = footer2.attributes.items.data || ``;

  return (
    <Flex
      width={{ base: `100%`, md: `66%` }}
      marginTop={{ base: `.5rem`, md: `0` }}
      fontSize="sm">
      <UnorderedList
        listStyleType="none"
        marginInlineStart="0"
        width={{ base: `50%`, md: `50%` }}>
        {footerMenu1.map((item, i) => (
          <ListItem
            key={`menu-item-${i + 1}`}
            marginBottom="1rem"
            fontWeight="600">
            <Link
              href={item.attributes.url}
              onClick={() => {
                dataLayerClick({
                  event: `cta_click`,
                  clickText: item.attributes.title,
                  clickUrl: item.attributes.url
                });
              }}>
              {item.attributes.title}
            </Link>
          </ListItem>
        ))}
      </UnorderedList>
      <UnorderedList
        listStyleType="none"
        marginInlineStart="0"
        width={{ base: `50%`, md: `50%` }}>
        {footerMenu2.map((item, i) => (
          <ListItem
            key={`menu-item-${i + 1}`}
            marginBottom="1rem"
            fontWeight="600">
            <Link
              href={item.attributes.url}
              onClick={() => {
                dataLayerClick({
                  event: `cta_click`,
                  clickText: item.attributes.title,
                  clickUrl: item.attributes.url
                });
              }}>
              {item.attributes.title}
            </Link>
          </ListItem>
        ))}
      </UnorderedList>
    </Flex>
  );
};

export default FooterMenu;
